import React, { memo } from 'react';
import { Route, Routes } from 'react-router-dom';

import { ConfigurationPage } from '../components/pages/ConfigurationPage';
import { ResourcesPage } from '../components/pages/ResourcesPage';
import { RmsPage } from '../components/pages/RmsPage';
import { RuleEditorPage } from '../components/pages/RuleEditorPage';
import { RmsGanttContextProvider } from '../components/Rms/RmsContent/RmsContext';
import { ROUTE_CONFIGURATION, ROUTE_EDITOR, ROUTE_HOME, ROUTE_RESOURCES, ROUTE_SETTINGS } from '../routes';
import { SettingsPage } from './Settings/SettingsPage/SettingsPage';

export const App = memo(function App() {
    return (
        <Routes>
            <Route
                path={`${ROUTE_HOME}/*`}
                element={
                    <RmsGanttContextProvider>
                        <RmsPage />
                    </RmsGanttContextProvider>
                }
            />
            <Route path={`${ROUTE_RESOURCES}/*`} element={<ResourcesPage />} />
            <Route path={`${ROUTE_CONFIGURATION}/*`} element={<ConfigurationPage />} />
            <Route path={`${ROUTE_EDITOR}/*`} element={<RuleEditorPage />} />
            <Route path={ROUTE_SETTINGS} element={<SettingsPage />} />
            {/*<Route path={ROUTE_HELP} element={<HelpPage />} />*/}
        </Routes>
    );
});
